export const URL_SCHEME_REGEX = /^[a-z][a-z\d+.-]*:/i
